import React, { ReactNode } from "react";
import "../../styles/styles.css"

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <div className={`bgColor nc-LayoutPage relative `}>
        <div className="p-5 mx-auto bg-white rounded-xl sm:rounded-3xl lg:rounded-[40px] shadow-lg dark:bg-neutral-900">
          {children}
        </div>
    </div>
  );
};

export default Layout;
